import global_axios from '../../funciones_globales/interaccionapi';
import { INICIALIZAR_FORM } from '../generales/actionTypes';
import { CARGAR_INGRESOBODEGA } from './actionTypes';
import { completar_String } from '../../funciones_globales/format';
import { generarItemCatalogoSeleccionado } from '../../funciones_globales/catalogos';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_ValoresIniciales = (fechaProceso) => {
	return (dispatch) => {
		return global_axios({
			url: '/secuenciales/Ingreso',			
			method: 'GET',			
		})			
		.then( response => {						
			let cod_secuencial = completar_String(response.data.codigo, '0', 6);
			
			dispatch({
				type: INICIALIZAR_FORM,
				data: {	codigo: cod_secuencial,
						fecha: fechaProceso
					}
			})
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;			
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar valores iniciales de ingreso de bodega', mensaje: msgError}
			});
		});
	}
}

export const cargar_IngresoBodega = (cod_ingreso) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/ingresosbodega/' + cod_ingreso,			
			method: 'GET'
		})			
		.then( response => {			
			let ingresoBodega = response.data;
			ingresoBodega.proveedor = (ingresoBodega.prov===null?null:generarItemCatalogoSeleccionado(ingresoBodega.prov.Codigo, ingresoBodega.prov.Nombre));
			
			dispatch({
				type: CARGAR_INGRESOBODEGA,
				data: ingresoBodega
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar ingreso de bodega', mensaje: msgError}
			});
		});
	}
}